import React from 'react';
import { makeStyles } from '@mui/styles';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';

const theme = createTheme();

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin:  useTheme().spacing(2),
  },
  button: {
    margin:  useTheme().spacing(1, 1, 0, 0),
  },
  root: {
    flexGrow: 1,
    maxWidth: 600,
  },
  demo: {
    border: '#ccc solid 1px',
    marginBottom: '20px',
    borderRadius: 5
  }
}));


export default function CorreosForm(props) {
  const classes = useStyles();

  const listPart = (items) => (
    <RadioGroup aria-label="email" name="email" value={props.correoDest} onChange={props.handleCorreo}>
      {items.map((value) => {
        return (
          <FormControlLabel key={value.email} value={value.value} control={<Radio />} label={value.email} />
        );
      })}
    </RadioGroup>
);


return <ThemeProvider theme={theme}>
    <React.Fragment>
      <div className={classes.demo} >
        <FormControl component="fieldset" className={classes.formControl}>
          <FormLabel component="legend">Para continuar con el cambio de clave, selecciona una casilla a la que tengas acceso, si es tu primer ingreso como estudiante nuevo debes seleccionar tu casilla personal.</FormLabel>
            {props.correos.correosPART.length > 0 
              ? listPart(props.correos.correosPART)
              : listPart(props.correos.correosUSS)
            }
          <FormHelperText>Si ninguno de los correos que tenemos registrado corresponde, debes dirigirte a registro académico de tu sede.</FormHelperText>
        </FormControl>
      </div>
    </React.Fragment>
</ThemeProvider>;

}